import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CentroGestion } from '../../models/centro_gestion';
import { environment } from '../../../environments/environment';
import { Proveedor } from '../../models/proveedor';
import { TotalesOC } from '../../models/totales_oc';
import { map } from 'rxjs';
import { TotalesRecibir } from '../../models/totales_recibir';
import { CantidadProveedores } from '../../models/cantidad_proveedores';
import { EvolucionOC } from '../../models/evolucion_oc';
import { RankingProveedor } from '../../models/ranking_proveedor';
import { TipoCompra } from '../../models/tipo_compra';
import { CentroOC } from '../../models/centro_oc';
import { OCConvenio } from '../../models/oc_convenio';
import { OCMenorQue } from '../../models/oc_menor_que';
import { OCMayorQue } from '../../models/oc_mayor_que';
import { CentroOCMonthly } from '../../models/centro_oc_monthly';
import { OCConvenioMonthly } from '../../models/oc_convenio_monthly';
import { OCMenorQueMonthly } from '../../models/oc_menor_que_monthly';
import { OCMayorQueMonthly } from '../../models/oc_mayor_que_monthly';
import { ICCookieService } from '../cookie/iccookie.service';

@Injectable({
  providedIn: 'root',
})
export class OrdenCompraService {
  idEmpresa: string = '0';

  constructor(
    private http: HttpClient,
    private _ICCookieService: ICCookieService
  ) {
    this.idEmpresa = this._ICCookieService.getCookie('IDEMPRESA') || '0';
  }

  getCentrosGestion() {
    return this.http.get<CentroGestion[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/centros_de_gestion`
    );
  }

  getProveedores() {
    return this.http.get<Proveedor[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/proveedores`
    );
  }

  getTotalesOC(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<TotalesOC[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/totales_oc`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getTotalesPorRecibir(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<TotalesRecibir[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/totales_por_recibir`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getCantidadProveedores(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<CantidadProveedores[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cantidad_proveedores`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getEvolucionOc(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<EvolucionOC[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/evolucion_oc`,
      { params }
    );
  }

  getRankinProveedores(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<RankingProveedor[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/ranking_proveedores`,
      { params }
    );
  }

  getTipoCompra(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<TipoCompra[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/tipo_compra`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getCentroOC(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<CentroOC[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/centros_oc`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getOCConvenio(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<OCConvenio[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/oc_convenio`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getOCMenorQue(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<OCMenorQue[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/oc_menores_que`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getOCMayoresQue(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<OCMayorQue[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/oc_mayores_que`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getCentroOCMonthly(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<CentroOCMonthly[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/centros_oc_monthly`,
      { params }
    );
  }

  getOCConvenioMonthly(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<OCConvenioMonthly[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/oc_convenio_monthly`,
      { params }
    );
  }

  getOCMenorQueMonthly(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<OCMenorQueMonthly[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/oc_menores_que_monthly`,
      { params }
    );
  }

  getOCMayoresQueMonthly(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<OCMayorQueMonthly[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/oc_mayores_que_monthly`,
      { params }
    );
  }

  getReporteOc(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/oc-reporte`,
        { params, responseType: 'blob' }
      );
  }
  getDummy() {
    return Promise.resolve([
      {
        id: 1000,
        name: 'James Butt',
        country: {
          name: 'Algeria',
          code: 'dz',
        },
        company: 'Benton, John B Jr',
        date: '2015-09-13',
        status: 'unqualified',
        verified: true,
        activity: 17,
        representative: {
          name: 'Ioni Bowcher',
          image: 'ionibowcher.png',
        },
        balance: 70663,
      },
      {
        id: 1001,
        name: 'Josephine Darakjy',
        country: {
          name: 'Egypt',
          code: 'eg',
        },
        company: 'Chanay, Jeffrey A Esq',
        date: '2019-02-09',
        status: 'proposal',
        verified: true,
        activity: 0,
        representative: {
          name: 'Amy Elsner',
          image: 'amyelsner.png',
        },
        balance: 82429,
      },
      {
        id: 1002,
        name: 'Art Venere',
        country: {
          name: 'Panama',
          code: 'pa',
        },
        company: 'Chemel, James L Cpa',
        date: '2017-05-13',
        status: 'qualified',
        verified: false,
        activity: 63,
        representative: {
          name: 'Asiya Javayant',
          image: 'asiyajavayant.png',
        },
        balance: 28334,
      },
      {
        id: 1003,
        name: 'Lenna Paprocki',
        country: {
          name: 'Slovenia',
          code: 'si',
        },
        company: 'Feltz Printing Service',
        date: '2020-09-15',
        status: 'new',
        verified: false,
        activity: 37,
        representative: {
          name: 'Xuxue Feng',
          image: 'xuxuefeng.png',
        },
        balance: 88521,
      },
      {
        id: 1004,
        name: 'Donette Foller',
        country: {
          name: 'South Africa',
          code: 'za',
        },
        company: 'Printing Dimensions',
        date: '2016-05-20',
        status: 'proposal',
        verified: true,
        activity: 33,
        representative: {
          name: 'Asiya Javayant',
          image: 'asiyajavayant.png',
        },
        balance: 93905,
      },
      {
        id: 1005,
        name: 'Simona Morasca',
        country: {
          name: 'Egypt',
          code: 'eg',
        },
        company: 'Chapman, Ross E Esq',
        date: '2018-02-16',
        status: 'qualified',
        verified: false,
        activity: 68,
        representative: {
          name: 'Ivan Magalhaes',
          image: 'ivanmagalhaes.png',
        },
        balance: 50041,
      },
      {
        id: 1006,
        name: 'Mitsue Tollner',
        country: {
          name: 'Paraguay',
          code: 'py',
        },
        company: 'Morlong Associates',
        date: '2018-02-19',
        status: 'renewal',
        verified: true,
        activity: 54,
        representative: {
          name: 'Ivan Magalhaes',
          image: 'ivanmagalhaes.png',
        },
        balance: 58706,
      },
      {
        id: 1007,
        name: 'Leota Dilliard',
        country: {
          name: 'Serbia',
          code: 'rs',
        },
        company: 'Commercial Press',
        date: '2019-08-13',
        status: 'renewal',
        verified: true,
        activity: 69,
        representative: {
          name: 'Onyama Limba',
          image: 'onyamalimba.png',
        },
        balance: 26640,
      },
      {
        id: 1008,
        name: 'Sage Wieser',
        country: {
          name: 'Egypt',
          code: 'eg',
        },
        company: 'Truhlar And Truhlar Attys',
        date: '2018-11-21',
        status: 'unqualified',
        verified: true,
        activity: 76,
        representative: {
          name: 'Ivan Magalhaes',
          image: 'ivanmagalhaes.png',
        },
        balance: 65369,
      },
      {
        id: 1009,
        name: 'Kris Marrier',
        country: {
          name: 'Mexico',
          code: 'mx',
        },
        company: 'King, Christopher A Esq',
        date: '2015-07-07',
        status: 'proposal',
        verified: false,
        activity: 3,
        representative: {
          name: 'Onyama Limba',
          image: 'onyamalimba.png',
        },
        balance: 63451,
      },
      {
        id: 1010,
        name: 'Minna Amigon',
        country: {
          name: 'Romania',
          code: 'ro',
        },
        company: 'Dorl, James J Esq',
        date: '2018-11-07',
        status: 'qualified',
        verified: false,
        activity: 38,
        representative: {
          name: 'Anna Fali',
          image: 'annafali.png',
        },
        balance: 71169,
      },
      {
        id: 1011,
        name: 'Abel Maclead',
        country: {
          name: 'Singapore',
          code: 'sg',
        },
        company: 'Rangoni Of Florence',
        date: '2017-03-11',
        status: 'qualified',
        verified: true,
        activity: 87,
        representative: {
          name: 'Bernardo Dominic',
          image: 'bernardodominic.png',
        },
        balance: 96842,
      },
      {
        id: 1012,
        name: 'Kiley Caldarera',
        country: {
          name: 'Serbia',
          code: 'rs',
        },
        company: 'Feiner Bros',
        date: '2015-10-20',
        status: 'unqualified',
        verified: false,
        activity: 80,
        representative: {
          name: 'Onyama Limba',
          image: 'onyamalimba.png',
        },
        balance: 92734,
      },
      {
        id: 1013,
        name: 'Graciela Ruta',
        country: {
          name: 'Chile',
          code: 'cl',
        },
        company: 'Buckley Miller & Wright',
        date: '2016-07-25',
        status: 'negotiation',
        verified: false,
        activity: 59,
        representative: {
          name: 'Amy Elsner',
          image: 'amyelsner.png',
        },
        balance: 45250,
      },
      {
        id: 1014,
        name: 'Cammy Albares',
        country: {
          name: 'Philippines',
          code: 'ph',
        },
        company: 'Rousseaux, Michael Esq',
        date: '2019-06-25',
        status: 'new',
        verified: true,
        activity: 90,
        representative: {
          name: 'Asiya Javayant',
          image: 'asiyajavayant.png',
        },
        balance: 30236,
      },
      {
        id: 1015,
        name: 'Mattie Poquette',
        country: {
          name: 'Venezuela',
          code: 've',
        },
        company: 'Century Communications',
        date: '2017-12-12',
        status: 'negotiation',
        verified: false,
        activity: 52,
        representative: {
          name: 'Anna Fali',
          image: 'annafali.png',
        },
        balance: 64533,
      },
      {
        id: 1016,
        name: 'Meaghan Garufi',
        country: {
          name: 'Malaysia',
          code: 'my',
        },
        company: 'Bolton, Wilbur Esq',
        date: '2018-07-04',
        status: 'unqualified',
        verified: false,
        activity: 31,
        representative: {
          name: 'Ivan Magalhaes',
          image: 'ivanmagalhaes.png',
        },
        balance: 37279,
      },
    ]);
  }
}
